'use client';

import { useEffect, useState } from 'react';

interface StatsCardProps {
    icon: string;
    value: string;
    label: string;
    delay?: number;
}

const StatsCard = ({ icon, value, label, delay = 0 }: StatsCardProps) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), delay);
        return () => clearTimeout(timer);
    }, [delay]);

    return (
        <div
            className={`
                glass glass-border rounded-xl p-6 text-center transform transition-all duration-700
                ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}
                hover:-translate-y-2 hover:shadow-glow
            `}
        >
            <div className="text-4xl mb-4">{icon}</div>
            <div className="text-3xl font-bold text-text-primary mb-2 gradient-text">{value}</div>
            <div className="text-text-secondary font-medium">{label}</div>
        </div>
    );
};

export default StatsCard;
